export var guardStatus=function(a){return"error"===a?"alert":a};
//# sourceMappingURL=guardStatus.js.map